import { onClickStaticMapType } from 'components/map/map-controller/main/leaflet-click/click-updateSlot';
import { MarkerOptionsMap } from 'components/map/themes/pill-theme';
import { MarkerDisplaySize, RadioFilterTypes } from 'types/location';
import { IMarker } from 'types/markerCore/marker-core-type';
import { MarkerTypeName } from 'types/markerTypesV2/m-v2-core';
import { IMarkerV2 } from 'types/markerTypesV2/m-v2-general';
import { predicateMarkerV1 } from 'utilities/isType';
import { MarkerLabelV2 } from './marker-label-v2';
import { MarkerFilterPillV2 } from './marker-pill-filter-v2';
import { MarkerPillV2 } from './marker-pill-v2';

export const getMarkerV2TextPos = (m: IMarker) => {
  if (predicateMarkerV1(m)) {
    return undefined;
  }
  if (m.type === MarkerTypeName.Label) {
    return undefined;
  }
  /**
   * Unless stated we do not want pill pointers point to overlap the label
   * Default to left if no textPos is defined
   */
  if (!m.position?.textPos) {
    if (m.position.labelPos === 'left' && m.view?.hasPoint) {
      return 'left';
    }
  }
  return m.position?.textPos;
};

export const MarkerViewV2 = (props: {
  marker: IMarkerV2;
  markerDisplaySize: MarkerDisplaySize;
  selected?: boolean;
  mockHover?: boolean;
  markerThemes?: MarkerOptionsMap;
  onClick?: onClickStaticMapType;
  stationType?: RadioFilterTypes;
}) => {
  if (props.marker) {
    if (props.marker.type === MarkerTypeName.Label) {
      return <MarkerLabelV2 {...props} marker={props.marker} />;
    }
    if (props.marker.type === MarkerTypeName.FilterPill) {
      return <MarkerFilterPillV2 {...props} marker={props.marker} />;
    }
    if (props.marker.type === MarkerTypeName.Pill) {
      return <MarkerPillV2 {...props} marker={props.marker} />;
    }
    // V2 Marker Default
    return <MarkerPillV2 {...props} marker={props.marker} />;
  }
};
